import { apiUrl } from '../utils/constants';
import { DELETE, GET, POST, PUT } from './api.service.wrapper';



export const GetVideo = async (keyword = '', page = '', perPage = '', is_paginate = 1, status = null,category_id) => {
    let params = {};

    if (page) {
        params['page'] = page;
    }

    if (perPage) {
        params['per_page'] = perPage;
    }

    if (keyword) {
        params['title'] = keyword;
    }

    if (category_id) {
        params['category_id'] = category_id;
    }

    if (status) {
        params['status'] = status;
    }
    params['paginate'] = is_paginate;

    const response = await GET(apiUrl.video, params);
    return response;
}

export const GetVideoById = async (id) => {
    let params = {};
    let response = '';
    response = await GET(apiUrl.video + '/' + id,params);
    return response;
}

export const CreateVideo = async (data) => {
    const response = await POST(apiUrl.video, data);
    return response;
}

export const UpdateVideo = async (id, data) => {
    const response = await PUT(apiUrl.video, id, data);
    return response;
}

export const DeleteVideo = async (id) => {
    const response = await DELETE(apiUrl.video, id);
    return response;
}
